import React from 'react';

function YourNetwork(props) {
    return (
        <div className='container'>
            <h3>Network Page</h3>
        </div>
    );
}

export default YourNetwork;